import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import ProcessHandover from '../ProcessHandover'
import PageResult from "../PageResult";

import { alertUser } from 'logic/eventBeforeunload';

import success from '../../../assets/icons/figma/icon-success.svg'
import error from '../../../assets/icons/figma/icon-error.svg'

export default function ThankYou() {

  const {
    code,
    retriesLeft,
    applicationParams,
  } = useSelector((state) => ({
    code: state => state.checkResult,
    retriesLeft: state.passiveLivenessTest.retriesLeft,
    applicationParams: state.setApplicationParams,
  }));

  const [currentPage, setCurrentPage] = useState('')
  const [icon, setIcon] = useState(success)
  const [titleText, setTitleTxt] = useState('ยืนยันตัวตน (e-KYC) \nเรียบร้อยแล้ว')
  const [des, setDes] = useState('การจัดเก็บข้อมูลครั้งนี้ ใช้เพื่อการยืนยันตัวตนในการสมัครเอาประกันเท่านั้น')
  const [buttonText, setButtonText] = useState('ถัดไป')

  const showError = () => (code === '1' || retriesLeft < 0);
  
  const secondDevice = () => applicationParams.secondDevice === "yes"
  const hideSuccessPage = () => applicationParams.hideSuccessPage === 'y'
  
  const handleClickButton = () => {
    window.removeEventListener('beforeunload', alertUser);
    if (secondDevice()) {
      window.close();
      return;
    }

    if (showError()) {
      window.location.reload();
      return;
    }
    
    setCurrentPage('PROCESS_HANDOVER');
  }

  useEffect(() => {
    
    if(showError()) {
      setIcon(error)
      setTitleTxt('การยืนยันตัวตนไม่สำเร็จ')
      setDes('ไม่สามารถยืนยันตัวตนของคุณได้\nกรุณาลองใหม่อีกครั้ง')
      setButtonText('กรุณาลองใหม่อีกครั้ง')
    }
  }, [])

  useEffect(() => {
    if(secondDevice()) {
      setDes('การจัดเก็บข้อมูลครั้งนี้ \nใช้สำหรับยืนยันตัวตนเพื่อสมัครเอาประกันเท่านั้น \nกรุณาดำเนินการต่อบนอุปกรณ์ที่ใช้สมัคร')
      setButtonText('ปิดหน้านี้')
    }
  }, [])

  useEffect(() => {
    if (hideSuccessPage()) {
      handleClickButton()
    }
  }, [])

  if(currentPage === 'PROCESS_HANDOVER') {
    return <ProcessHandover />
  }
  
  return (
    <PageResult
      header="ยืนยันตัวตน e-KYC"
      icon={icon}
      titleText={titleText}
      des={des}
      buttonText={buttonText}
      onClick={handleClickButton}
    />
  )
}
